import { useMemo } from "react";
import { findWhere } from "underscore";
import useGlobals from "../../../../api/api-hooks/globals/useGlobal";
import { View } from "../../../../types/PageInterfaces";

const useDefaultPrefill = ({ view }: { view: View }) => {
  const { globals: quickCreates, globalsLoading: quickCreatesLoading } =
    useGlobals("QuickCreates");

  return useMemo(() => {
    const selectedID = view?._SelectedPrefill;
    if (!selectedID || quickCreatesLoading) return null;

    const foundPrefill = findWhere(view?.Prefills, {
      id: selectedID,
    });

    if (!foundPrefill) return null;

    if (!!foundPrefill?.GlobalID) {
      const gqc = findWhere(quickCreates, { id: foundPrefill?.GlobalID });

      if (!gqc) return null;

      return { ...gqc, ...foundPrefill };
    }

    return foundPrefill;
  }, [
    view?.Prefills,
    view?._SelectedPrefill,
    quickCreates,
    quickCreatesLoading,
  ]);
};

export default useDefaultPrefill;
